module.exports = __webpack_public_path__ + "static/media/IMG_4265.b29e7116.PNG";